import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import guide from "../content/guide.md" with { type: "text" };

export function MarkdownPanel() {
  return (
    <section
      aria-label="Markdown"
      className="min-h-0 min-w-0 overflow-auto px-6 py-6 lg:px-8 lg:py-8"
    >
      <article className="prose prose-neutral max-w-none prose-headings:font-semibold prose-headings:tracking-tight prose-pre:bg-example prose-pre:text-foreground prose-code:before:content-none prose-code:after:content-none [&_:not(pre)>code]:rounded [&_:not(pre)>code]:bg-example [&_:not(pre)>code]:px-1 [&_:not(pre)>code]:py-0.5">
        <Markdown remarkPlugins={[remarkGfm]}>{guide}</Markdown>
      </article>
    </section>
  );
}
